import {Component, EventEmitter, Input, OnChanges, OnDestroy, Output, ChangeDetectionStrategy} from '@angular/core';
import {PayrollService} from '../../../services/payroll/payroll.service';
import {MatchingSelection, WorkforceTeamCriteriaState} from '../../../services/payroll-workforce/workforce-team-criteria.state';
import {WorkforceTeamCreationState} from '../../../services/payroll-workforce/workforce-team-creation.state';
@Component({
    selector: 'app-payroll-workforce-criteria', templateUrl: './payroll-workforce-criteria.component.html', styleUrls: ['./payroll-workforce-criteria.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PayrollWorkforceCriteriaComponent implements OnChanges, OnDestroy {
  @Input() companyId = ''; @Input() snapshotId = ''; @Input() teamId = '';
  @Input() creation!: WorkforceTeamCreationState;
  @Output() selector = new EventEmitter<MatchingSelection | null>();
  @Output() selectionMode = new EventEmitter<boolean>();
  @Output() criteriaChanged = new EventEmitter<void>();
  @Input() state: WorkforceTeamCriteriaState;
  @Input() editorOnly = false;
  @Input() disabled = false;
  allMatching = false;
  constructor(api: PayrollService) {
    this.state = new WorkforceTeamCriteriaState(api, () => {
      this.selector.emit(this.allMatching ? this.state.selection : null);
      if (!this.state.preview) this.criteriaChanged.emit();
    });
  }
  ngOnChanges(): void { if (!this.editorOnly) { void this.state.open(this.companyId, this.snapshotId, this.teamId); } }
  ngOnDestroy(): void { if (!this.editorOnly) { this.state.destroy(); } }
  selectionChanged(): void { this.selectionMode.emit(this.allMatching); this.selector.emit(this.allMatching ? this.state.selection : null); }
  get operationActive(): boolean {
    const progress = this.creation?.progress;
    return this.disabled || !!this.creation?.busy || !!progress && !['complete', 'closed'].includes(progress.phase);
  }
  async refresh(): Promise<void> {
    const selection = this.state.selection;
    if (!selection || !this.teamId || this.operationActive) { return; }
    try { await this.creation.submit({snapshotId: selection.snapshotId, teamId: this.teamId,
      selection: {mode: 'all_matching', criteria: selection.criteria, revision: selection.revision}}); }
    catch (_) { /* The operation state provides a safe, actionable message. */ }
  }
}
